import { Invoice } from "../../../domain/invoicing/invoice";
import { SendInvoiceRequest } from "../../../domain/invoicing/invoicingApi";

export const initializeSendInvoiceRequest = (invoice: Invoice, emailAddresses: string[]): SendInvoiceRequest => {
  return {
    invoiceId: invoice.id,
    emailAddresses,
    invoiceUpdates: {
      dueOn: invoice.dueOn,
      enableCreditCardPayments: invoice.enableCreditCardPayments,
      enableAchPayments: invoice.enableAchPayments,
      showAuthorizePaymentOnFile: invoice.showAuthorizePaymentOnFile,
      requireAuthorizePaymentOnFile: invoice.requireAuthorizePaymentOnFile,
    }
  }
}